const handleOnStateChanged = (state, debugSession, SessionState, setIsReady, setIsVideoPaused, setIsVideoBuffering) => {
  debugSession.extend("state")(state);
  if (state === "Playing") {
    setIsReady(true);
    setIsVideoPaused(false);
  } else if (state === "Paused") {
    setIsVideoPaused(true);
    setIsReady(true);
  }
  if ([SessionState.Rebuffering, SessionState.Seeking, SessionState.Loading].includes(state)) {
    setIsVideoBuffering(true);
  } else {
    setIsVideoBuffering(false);
  }
};
export {
  handleOnStateChanged
};
//# sourceMappingURL=sessionEventHandlers.js.map
